import type { FC } from 'react';
import React from 'react';
import styled, { css } from 'styled-components';

import LtLogo, { PartnerLogo } from '@lt/components/components/Logo';
import { isSSR } from 'src/helpers/ssr';
import type { PartnerLogo as IPartnerLogo } from '../../../../store/menu/types';

interface Props {
  isMobile: LT.isMobile;
  isNewYear: boolean;
  isBlack: boolean;
  partnerLogo?: IPartnerLogo | null;
  inWidget?: boolean;
  isHomepage?: boolean;
  isWhiteLabel: boolean;
}

const HeaderLogo: FC<Props> = ({
  partnerLogo,
  isMobile,
  isNewYear,
  inWidget,
  isBlack,
  isHomepage,
  isWhiteLabel,
}) => {
  if (isSSR && isWhiteLabel) return null;

  if (partnerLogo)
    return (
      <PartnerLogo
        src={partnerLogo.src}
        srcSet={partnerLogo.srcset}
        isMobile={isMobile}
        maxWidth={isHomepage ? 500 : 200}
      />
    );

  return (
    <LogoWrapper $isMobile={isMobile} $inWidget={inWidget}>
      <StyledLtLogo
        isNewYear={isNewYear}
        $inWidget={inWidget}
        $isMobile={isMobile}
        $isHomepage={isHomepage}
        isBlack={isBlack}
        isCompact={!inWidget && !isBlack && !isHomepage}
      />
    </LogoWrapper>
  );
};

const LogoWrapper = styled.div<{
  $isMobile?: boolean;
  $inWidget?: boolean;
}>`
  ${({ $inWidget, $isMobile }) =>
    $inWidget &&
    $isMobile &&
    css`
      position: absolute;
      top: 3px;
      width: 100%;
      right: 0;
      display: flex;
      justify-content: center;
      height: 40px;
    `}
`;

const StyledLtLogo = styled(LtLogo)<{
  $inWidget?: boolean;
  $isMobile?: boolean;
  $isHomepage?: boolean;
  isBlack?: boolean;
}>`
  ${({ $inWidget, $isMobile, isBlack, $isHomepage }) => {
    if (isBlack) return '';
    if ($isHomepage) {
      return 'padding-top: 0px;';
    }
    if ($inWidget) {
      return $isMobile
        ? css`
            height: 40px;
            margin-top: 10px;
          `
        : '';
    }
    return $isMobile
      ? css`
          width: 30px;
          margin: 0 10px 0 10px;
          padding-top: 23.5px;
        `
      : `padding-top: 24px;`;
  }};
`;

export default HeaderLogo;
